import _ from 'lodash';
import autobind from 'autobind-decorator';

import {
	observable,
	computed,
	action,
	runInAction,
	extendObservable
} from 'mobx';

import { getAx } from 'shared/util';
import config from '../config';

const { getRoute, routes: { profile, login } } = config;

const STATE_IDLE = 0;
const STATE_LOADING = 1;
const STATE_SUCCESS = 2;
const STATE_ERROR = 3;

class APIStore {

	@observable
	data = {
		stats: {},
		user: {},
		artist: {},
		songs: [],
		albums: []
	};

	@observable
	dataState = STATE_IDLE;

	constructor () {
		const storedData = window.sessionStorage.getItem('hfm');
		let parsedData = {};

		if (storedData) {

			parsedData = JSON.parse(storedData);
			this.userID = parsedData.uid;
		}

		this.ax = getAx(parsedData);
    }

	@computed
	get isIdle () {
		return this.dataState === STATE_IDLE;
	}

	@computed
	get isLoading () {
		return this.dataState === STATE_LOADING;
	}

	@computed
	get isSuccess () {
		return this.dataState === STATE_SUCCESS;
	}

	@computed
	get isError () {
		return this.dataState === STATE_ERROR;
	}

	@action
	async getInitialPayload () {
		if (this.isLoading || this.isSuccess) {

			return;
		}

		try {

			this.dataState = STATE_LOADING;
			let userID = this.userID;


			if (_.isEmpty(userID) && (/^dev/).test(import.meta.env.MODE)) {

				userID = '4c65f7c9-3006-4f25-9467-208717ccca3b';
			}

			const response = await this.ax.get(getRoute('profile', userID));
			runInAction('Update with initial payload', () => this.data = response.data);
		} catch (error) {

			this.dataState = STATE_ERROR;
			console.log(error);

			if (error.response.status === 401) {

				window.location.href = login;
				return;
			}
		} finally {

			runInAction('Update with initial payload', () => this.dataState = STATE_SUCCESS);
		}
	}

	@action
	async setDefaultPassword (_id) {
		if (this.isLoading) {

			return;
		}

		try {

			this.dataState = STATE_LOADING;
			const { data } = await this.ax.post(getRoute('setDefaultPassword', _id));
			return data;
		} catch (error) {

			this.dataState = STATE_ERROR;
			console.log(error);

			if (error.response.status === 401) {

				window.location.href = login;
				return;
			}
		} finally {

			this.dataState = STATE_IDLE;
		}
	}
}

export default new APIStore();
